// source: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
(function() {
  if (typeof window.CustomEvent === 'function') return false

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined }
    var evt = document.createEvent('CustomEvent')
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
    return evt
  }

  CustomEvent.prototype = window.Event.prototype

  window.CustomEvent = CustomEvent
})()

// import external dependencies
import 'jquery';
import 'slick-carousel';

// Import everything from autoload
import './autoload/_foundation.js'; import './autoload/jquery.waypoints.min.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import templateMembers from './routes/templateMembers';
import templateSignup from './routes/templateSignup';
import postTypeArchivePtcResources from './routes/postTypeArchivePtc_resources';
import postTypeArchivePtcVendors from './routes/postTypeArchivePtc_vendors';
import taxPtcTypes from './routes/taxPtc_types';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  templateMembers,
  postTypeArchivePtcResources,
  postTypeArchivePtcVendors,
  templateSignup,
  taxPtcTypes,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js